<template>
    <!-- Not Used because of Inline Edit Employee -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-10">
            <h2 class="headerblock">
                <div class="row">
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                        <a href="javascript:;" class="btn btn-secondary btn-smm hidden-md-down" @click="InviteEmployee">
                            SAVE
                        </a>
                        <a href="javascript:;" @click="$router.go(-1)"
                            class="btn btn-white btn-smm btn-no-border-blue ml-3"
                            style="color: #00448b;background-color: transparent; box-shadow: none !important;">
                            CANCEL
                        </a>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <div class="breadcome-heading d-none d-xl-inline">
                            <div class="form-group formsearch has-warning has-feedback">
                                <input type="text" class="form-control textremove holder" id="inputWarning2"
                                    aria-describedby="inputWarning2Status" placeholder="Search...">
                                <!-- <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span> -->
                                <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                            </div>
                        </div>
                        <router-link :disabled="!$routerHistory.hasForward()"
                            :to="{ path: $routerHistory.next().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward"
                                placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-right"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                        <router-link :disabled="!$routerHistory.hasPrevious()"
                            :to="{ path: $routerHistory.previous().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back"
                                placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-left"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                    </div>
                </div>
            </h2>
            <div class="page-layout carded left-sidebar" style="overflow-y: visible;">
                <div class="page-content-wrapper" style="border-radius: 15px;padding: 0px !important;">
                    <div class="page-content custom-scrollbar py-4 px-1"
                        style="border-radius: 15px;background-color: #d6e2ef !important;">
                        <h5 class="page-content-header-text">EDIT EMPLOYEE</h5>
                        <form>
                            <input autocomplete="off" name="hidden" type="text" style="display:none;">
                            <div class="pl-15 pr-15">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="form-group fieldGroup">
                                            <!-- <input class="inputField" name="first_name" type="text" v-model="employeeInfo.first_name" placeholder="Enter First Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">First Name<sup class="prefixIcon">*</sup></label> -->

                                            <input class="inputField" type="text" data-vv-scope="employeeInfo"
                                                data-vv-as="First Name" name="first_name"
                                                :maxlength="maxlengthemployeefirstname"
                                                v-model="employeeInfo.first_name" v-validate="'required'"
                                                placeholder="Enter First Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">First Name<sup
                                                    class="prefixIcon">*</sup></label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeefirstname - employeeInfo.first_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('employeeInfo.first_name')">{{errors.first('employeeInfo.first_name')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" type="text" v-model="employeeInfo.middle_name"
                                                placeholder="Enter Middle Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Middle Name</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-group fieldGroup">
                                            <!-- <input class="inputField" type="text" name="last_name" v-model="employeeInfo.last_name" placeholder="Enter Last Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Last Name</label> -->


                                            <input class="inputField" type="text" name="last_name"
                                                data-vv-scope="employeeInfo" data-vv-as="Last Name"
                                                :maxlength="maxlengthemployeelastname" v-model="employeeInfo.last_name"
                                                v-validate="'required'" placeholder="Enter Last Name">
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Last Name</label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeelastname - employeeInfo.last_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('employeeInfo.last_name')">{{errors.first('employeeInfo.last_name')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-lg-4 mt-3">
                                        <div class="form-check form-check-inline">
                                            <label class="form-label-radio text-secondary fw-600">
                                                Gender<sup class="fs-14 ml-02 mandatory">*</sup>
                                            </label>
                                        </div>
                                        <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="true" type="radio"
                                                        v-model="employeeInfo.user.gender" name="gender" selected
                                                        value="Male">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Male</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="true" type="radio"
                                                        v-model="employeeInfo.user.gender" name="gender" value="Female">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Female</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="true" type="radio"
                                                        v-model="employeeInfo.user.gender" name="gender" value="Others">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Custom</span>
                                                </label>
                                            </div>
                                            <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('userData.gender')">{{errors.first('userData.gender')}}</span> -->
                                        </div>
                                    </div>
                                    <div class="col-lg-4 nt-3" v-if="employeeInfo.gender=='Others'">
                                        <span class="text-secondary whiteSpace vselectLabel fw-600">Please Refer to me
                                            as<sup class="fs-14 ml-1 mandatory">*</sup></span>
                                        <v-select class="vselect-custom" :disabled="true" data-vv-scope="employeeInfo"
                                            v-model="employeeInfo.custom_gender.preposition" v-validate="'required'"
                                            required name="preposition" placeholder="Select Preposition"
                                            :options="['Mr.', 'Mrs.', 'Miss', 'Sir', 'Madam']" style="width: 100%;">
                                        </v-select>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('employeeInfo.preposition')">{{errors.first('employeeInfo.preposition')}}</span>
                                    </div>
                                    <div class="col-lg-4 mt-6" v-if="employeeInfo.gender=='Others'">
                                        <div class="form-group">
                                            <input class="inputField" :disabled="true" type="text"
                                                data-vv-scope="employeeInfo" name="gender" data-vv-as="Gender"
                                                v-model="employeeInfo.custom_gender.gender" placeholder="Enter Gender">
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fs-14 fw-600">Gender(Optional)</label>
                                            <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('userData.gender')">This Field Is Required</span> -->
                                        </div>
                                    </div>
                                    <div class="col-lg-4 mt-6">
                                        <div class="form-group fieldGroup">
                                            <input class="inputField" name="email" :disabled="true"
                                                v-model="employeeInfo.user.primary_email" type="email" required>
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Personal Email<sup
                                                    class="fs-14 ml-1 mandatory">*</sup></label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4" style="margin-top: 7px;">
                                        <div class="form-group fieldGroup">
                                            <span class="text-secondary whiteSpace fs-14 fw-600">Business Email<sup
                                                    class="fs-14 ml-1 mandatory">*</sup></span>
                                            <div class="input-group digi-input-group-dropdown">
                                                <input type="text" class="form-control" :disabled="true"
                                                    v-model="employeeInfo.email_id" placeholder="Enter Business Email">
                                                <!-- <span class="invalid-feedback-form text-danger" v-if="this.EmailExists">Primary Email already Exists!!</span> -->
                                                <!-- <div class="input-group-append">
                                                <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown">@digicollect.com</button>
                                                <div class="dropdown-menu dropdown-menu-right">
                                                    <a href="javascript:;" class="dropdown-item">@digicollect.com</a>
                                                    <a href="javascript:;" class="dropdown-item">@convalt.com</a>
                                                    <a href="javascript:;" class="dropdown-item">@gmail.com</a>
                                                    <a href="javascript:;" class="dropdown-item">@outlook.com</a>
                                                </div>
                                            </div> -->
                                            </div>
                                        </div>
                                        <!-- <div class="form-group fieldGroup">
                                            <input class="inputField" name="email"  type="text" required>
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel">Business Email</label>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row mt-6">
                                    <div class="col-lg-4">
                                        <span class="text-secondary whiteSpace fs-14 fw-600">Phone Number<sup
                                                class="fs-14 ml-1 mandatory">*</sup></span>
                                        <vue-tel-input class="teleContact mt-2" data-vv-scope="employeeInfo"
                                            data-vv-as="Phone Number" id="business_phone_number" name="phone_number"
                                            v-model="employeeInfo.user.primary_phone.phone_number"
                                            v-on:country-changed="countryChanged($event, 'employee_phone', 0)"
                                            ref="telInput" placeholder="Enter Phone Number" :disabledFormatting="false"
                                            :valid-characters-only="true" v-validate="{required:true,min:15}"
                                            :maxLen="maxPhoneLength" autocomplete="off"></vue-tel-input>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('employeeInfo.phone_number')">{{errors.first("employeeInfo.phone_number")}}</span>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="form-check form-check-inline">
                                            <label class="form-label-radio text-secondary fw-600">
                                                User Access<sup class="fs-14 ml-02 mandatory">*</sup>
                                            </label>
                                        </div>
                                        <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                            <div class="form-check form-check-inline user-perm">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" type="radio" value="true"
                                                        v-model="employeeInfo.is_superadmin" @click='onToggleIsAdmin()'
                                                        name="useraccess">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Super Admin</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline user-perm">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" type="radio" value="true"
                                                        v-model="employeeInfo.is_admin" @click='onToggleAdmin()'
                                                        name="useraccess">
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Admin</span>
                                                </label>
                                            </div>
                                            <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('userData.useraccess')">{{errors.first('userData.useraccess')}}</span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-6">
                                    <div class="col-lg-12">
                                        <div class="heading-title">
                                            Set Products Permissions
                                        </div>
                                        <table id="table-app-access" class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 30%;">Product</th>
                                                    <th style="width: 30%;">Admin Access</th>
                                                    <th style="width: 40%;">Permission</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(product, index) in products" :key="index">
                                                    <td style="width: 30%;">{{product.product_name}}</td>
                                                    <td style="width: 30%;">
                                                        <span class="switch switch-lg mr-2" style="top: 4px;">
                                                            <input type="checkbox"
                                                                :checked="Object.keys(employee_products).indexOf(product._id) !== -1"
                                                                :id="'productuid'+index.toString()"
                                                                :clicked='product.has_access'
                                                                @click="addProduct(product, index)" class="switch">
                                                            <label :for="'productuid'+index.toString()"></label>
                                                        </span>
                                                    </td>
                                                    <td style="width: 40%;">
                                                        <span v-for="(item, productIndex) in userProducts"
                                                            :key="productIndex">
                                                            <span
                                                                v-if="item.product == product._id && Object.keys(employee_products).indexOf(product._id) !== -1 && item.has_access">
                                                                <input type="radio" class="radiobutton"
                                                                    :id="'read'+index.toString()"
                                                                    :clicked="item.access_level=='2'"
                                                                    v-model="item.access_level"
                                                                    :name="'productuid'+index.toString()"
                                                                    @click="updateProductAcess(item,'2')" value="2">
                                                                <label :for="'read'+index.toString()"
                                                                    class="label-permissions">Read</label>

                                                                <input type="radio" class="radiobutton"
                                                                    :id="'write'+index.toString()"
                                                                    :clicked="item.access_level=='1'"
                                                                    v-model="item.access_level"
                                                                    :name="'productuid'+index.toString()"
                                                                    @click="updateProductAcess(item, '1')" value="1">
                                                                <label :for="'write'+index.toString()"
                                                                    class="label-permissions">Write</label>

                                                                <input type="radio" class="radiobutton"
                                                                    :id="'admin'+index.toString()"
                                                                    :clicked="item.access_level=='0'"
                                                                    v-model="item.access_level"
                                                                    :name="'productuid'+index.toString()"
                                                                    @click="updateProductAcess(item, '0')" value="0">
                                                                <label :for="'admin'+index.toString()"
                                                                    class="label-permissions">Admin</label>
                                                            </span>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import VueTelInput from "vue-tel-input";

    export default {
        data() {
            return {
                employeeInfo: {
                    first_name: "",
                    middle_name: "",
                    last_name: "",
                    primary_email: "",
                    primary_phone: {
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                    gender: "",
                    custom_gender: {
                        gender: "",
                        preposition: "",
                    },
                },
                is_admin: false,
                is_superadmin: false,
                products: [],
                EmailExists: false,
                userProducts: [],
                selected_products: {},
                permission_dict: {},
                initial_product_ids: [],
                employee_products: {},
                access_given: {},
                update_access: {},
                remove_access: {},
                maxPhoneLength: 15,
                maxlengthemployeefirstname: 20,
                maxlengthemployeelastname: 20,
                country: null
            };
        },
        components: {
            VueTelInput,
        },
        methods: {
            countryChanged(country, variable, index) {
                switch (variable) {
                    case 'employee_phone':
                        this.employeeInfo.user.primary_phone.dial_code = country.dialCode
                        this.employeeInfo.user.primary_phone.country_code = country.iso2
                        break
                }
            },
            onToggleIsAdmin() {
                this.is_superadmin = !this.is_superadmin;
                this.is_admin = false;
            },
            onToggleAdmin() {
                this.is_admin = !this.is_admin;
                this.is_superadmin = false;
            },
            addProduct(product, index) {

                product.has_access = true
                if (Object.keys(this.employee_products).indexOf(product._id) !== -1) {
                    product.has_access = false
                }
                if (product.has_access) {
                    this.userProducts.push({
                        has_access: true,
                        product: product._id,
                        access_level: product.access_level,
                    });
                    this.employee_products[product._id] = {
                        has_access: true,
                        access_level: product.access_level,
                    }
                    this.productAccessGiven(product);
                    if (product._id in this.remove_access) {
                        delete(this.remove_access[product._id])
                    }
                } else {
                    for (var i = 0; i < this.userProducts.length; i++) {
                        if (this.userProducts[i].product == product._id) {
                            this.userProducts.splice(i, 1);
                            delete(this.employee_products[product._id])
                            this.productAccessRemoved(product);
                        }
                    }
                    if (product._id in this.update_access) {
                        delete(this.update_access[product._id])
                    }
                }
            },
            editEmployee() {
                this.$http
                    .post("/employees/edit_employee", {
                        emp_data: this.employeeInfo,
                        select_product: this.access_given,
                        remove_product: this.remove_access,
                        permission_product: this.update_access
                    })
                    .then(res => {
                        if (res.data.status_id == 1) {
                            //alert("successfully")
                            this.$swal({
                                title: "Success!",
                                text: "Successfully Edited Your Information",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            }).then(() => {
                                this.$router.go(-1);
                            });
                        }

                    });
            },

            InviteEmployee() {
                this.$validator.validateAll("employeeInfo").then(result => {
                    if (result && !this.EmailExists) {
                        Object.keys(this.access_given).forEach(el => {
                            if (this.initial_product_ids.indexOf(el) !== -1) {
                                if (this.selected_products[el].access_level != this.access_given[el]
                                    .access_level) {
                                    this.update_access[el] = this.access_given[el]
                                }
                                delete(this.access_given[el])
                            }
                        });
                        Object.keys(this.update_access).forEach(el => {
                            if (Object.keys(this.selected_products).indexOf(el) !== -1) {
                                if (this.selected_products[el].access_level == this.update_access[el]
                                    .access_level) {
                                    delete(this.update_access[el])
                                }
                            }
                            Object.keys(this.remove_access).forEach(el => {
                                if (!this.initial_product_ids.indexOf(el) !== -1) {
                                    delete(this.remove_access[el])
                                }
                            });
                        })
                        this.editEmployee();
                    }
                })
            },
            checkEmail() {
                this.$http
                    .post("/users/check_primary_email", {
                        email_id: this.employeeInfo.email_id,
                    })
                    .then(response => {
                        this.EmailExists = response.data.status_id;
                    })
                    .catch(error => {
                    });
            },
            getProducts() {
                if (this.account) {
                    this.$http
                        .get("/company/get_products_purchased_not_purchased")
                        .then(res => {
                            if (res.data.status_id == 1) {
                                this.products = res.data.response.purchased_products;
                                this.products.forEach(product => {
                                    product.has_access = false;
                                    product.access_level = "2";
                                });
                                this.getEmployeeData();
                            }

                        });
                }
            },

            getEmployeeData() {
                this.$http
                    .post("employees/get_employee_data", {
                        emp_id: this.$route.params.id
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.employeeInfo = response.data.response;
                            this.setInitialProducts()
                        }
                    })
                    .catch(error => {
                    });
            },
            setInitialProducts() {
                this.products.forEach(pr => {
                    this.employeeInfo.products.forEach(product => {
                        if (pr._id == product.product) {
                            this.initial_product_ids.push(pr._id)
                            this.userProducts.push(product)
                            this.selected_products[pr._id] = {
                                has_access: true,
                                access_level: product.access_level,
                            }
                            if (product.has_access) {
                                this.employee_products[pr._id] = {
                                    has_access: product.has_access,
                                    access_level: product.access_level,
                                }
                            }
                        }
                    })
                })
            },
            productAccessGiven(product) {
                this.access_given[product._id] = product
            },
            updateProductAcess(updateProduct, value) {
                if (this.initial_product_ids.includes(updateProduct.product)) {
                    this.update_access[updateProduct.product] = updateProduct;
                } else {
                    this.access_given[updateProduct.product]["access_level"] = value;
                }
            },
            productAccessRemoved(product) {
                this.remove_access[product._id] = product
            }
        },
        created() {
            this.getProducts();
            const dict = {
                custom: {
                    first_name: {
                        required: () => 'First Name is Required'
                    },
                    last_name: {
                        required: () => 'Last Name is Required'
                    },
                    phone_number: {
                        required: () => "Phone Number is Required",
                        min: () => "Phone Number must Contain more than 9 Numbers",
                        regex: () => "Phone Number must Contain Valid Format"
                    }
                }
            }
            this.$validator.localize('en', dict)
        },
        computed: {
            account() {
                return this.$store.getters.account;
            },
        },
    };
</script>
<style>
    .previewElements {
        margin-bottom: 11px;
        margin-top: 3px;
    }

    .previewElementsContacts {
        margin-bottom: 2px;
        margin-top: 3px;
    }

    .select:focus {
        border-bottom: solid 1px #00448b !important;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    .selectMap {
        width: 22px;
        height: 22px;
        margin-left: 5px;
        object-fit: contain;
    }

    .socialMedia.dropdown-toggle::after {
        margin-left: 21px;
    }

    .companySelect.v-select input[type="search"] {
        padding: 0 5px !important;
    }

    @-moz-document url-prefix() {
        .inputMedia {
            padding-right: 26px !important;
        }
    }

    .input-group.digi-input-group-dropdown {
        border: 1px solid transparent !important;
    }

    .input-group.digi-input-group-dropdown>.form-control:disabled,
    .form-check-input:disabled {
        cursor: not-allowed !important;
    }

    .input-group.digi-input-group-dropdown>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 34px !important;
        padding: 6px 12px 6px 2px !important;
        color: #4e5764;
        border-bottom: 1px solid #a9aaad !important;
    }

    .input-group.digi-input-group-dropdown .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
        height: 34px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append button.btn.btn-link {
        text-transform: none !important;
        text-decoration: none !important;
        color: #303031 !important;
        height: 34px !important;
        line-height: 34px !important;
        font-weight: 500 !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box {
        overflow: visible !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content {
        border-radius: 15px;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content .v-modal-body {
        overflow: visible;
    }

    .heading-title {
        font-size: 14px;
        font-weight: 600;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        background-color: #00448b;
        padding: 20px 24px;
        color: #fff;
        text-transform: uppercase;
        line-height: normal;
        letter-spacing: 0.6px;
        text-align: center;
    }

    #table-app-access thead>tr {
        background: #fff;
    }

    #table-app-access thead tr th {
        text-transform: uppercase;
        color: #00448b;
    }

    #table-app-access thead tr th {
        padding: 16px 10px !important;
        border-bottom: 1px solid #e9ecef;
        vertical-align: middle;
    }

    #table-app-access tbody tr td,
    #table-app-access thead tr th {
        font-size: 13px;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.5px;
        padding-left: 24px;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #f5f6f9;
    }

    .table-striped tbody tr:nth-of-type(2n) {
        background-color: #fff;
    }

    #table-app-access tbody tr td {
        color: #4e5764;
    }

    #table-app-access tbody tr td {
        padding: 11px 10px !important;
        vertical-align: middle;
    }

    input[type="radio"].radiobutton {
        position: absolute;
        visibility: hidden;
        display: none;
        box-sizing: border-box;
        padding: 0;
    }

    label.label-permissions {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: #00448b !important;
        cursor: pointer;
        font-weight: bold;
        padding: 6px 14px;
        margin-bottom: 0px;
        margin-right: 0px;
        border: 1px solid #5ca7ec;
        border-radius: 4px;
    }

    input[type="radio"].radiobutton:checked+label.label-permissions {
        color: #fff !important;
        background: #00448b !important;
    }

    .radiooptions .form-check-inline.user-perm .form-check-label {
        width: 120px;
    }

    .radiooptions .form-check-inline.gender-radio .form-check-label {
        width: 66px;
    }

    .switch {
        font-size: 1rem;
        position: relative;
    }

    .switch input {
        position: absolute;
        height: 1px;
        width: 1px;
        background: 0 0;
        border: 0;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        overflow: hidden;
        padding: 0;
    }

    .switch input+label {
        position: relative;
        min-width: calc(calc(2.375rem * 0.8) * 2);
        border-radius: calc(2.375rem * 0.8);
        height: calc(2.375rem * 0.8);
        line-height: calc(2.375rem * 0.8);
        display: inline-block;
        cursor: pointer;
        outline: 0;
        user-select: none;
        vertical-align: middle;
        text-indent: calc(calc(calc(2.375rem * 0.8) * 2) + 0.5rem);
    }

    .switch input+label::after,
    .switch input+label::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: calc(calc(2.375rem * 0.8) * 2);
        bottom: 0;
        display: block;
    }

    .switch input+label::before {
        right: 0;
        background-color: #cdd2da;
        border-radius: calc(2.375rem * 0.8);
        transition: 0.2s all;
    }

    .switch input+label::after {
        top: 2px;
        left: 2px;
        width: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        height: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        border-radius: 50%;
        background-color: #fff;
        transition: 0.2s all;
    }

    .switch input:checked+label::before {
        background-color: #00448b;
    }

    .switch input:checked+label::after {
        margin-left: calc(2.375rem * 0.8);
    }

    .switch input:focus+label::before {
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 136, 221, 0.25);
    }

    .switch input:disabled+label {
        color: #868e96;
        cursor: not-allowed;
    }

    .switch input:disabled+label::before {
        background-color: #e9ecef;
    }

    .switch.switch-sm {
        font-size: 0.875rem;
    }

    .switch.switch-sm input+label {
        min-width: calc(calc(1.9375rem * 0.8) * 2);
        height: calc(1.9375rem * 0.8);
        line-height: calc(1.9375rem * 0.8);
        text-indent: calc(calc(calc(1.9375rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-sm input+label::before {
        width: calc(calc(1.9375rem * 0.8) * 2);
    }

    .switch.switch-sm input+label::after {
        width: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
        height: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-sm input:checked+label::after {
        margin-left: calc(1.9375rem * 0.8);
    }

    .switch.switch-lg {
        font-size: 1.25rem;
    }

    .switch.switch-lg input+label {
        min-width: calc(calc(3rem * 0.8) * 2);
        height: calc(3rem * 0.8);
        line-height: calc(3rem * 0.8);
        text-indent: calc(calc(calc(3rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-lg input+label::before {
        width: calc(calc(3rem * 0.8) * 2);
    }

    .switch.switch-lg input+label::after {
        width: calc(calc(3rem * 0.8) - calc(2px * 2));
        height: calc(calc(3rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-lg input:checked+label::after {
        margin-left: calc(3rem * 0.8);
    }

    .switch+.switch {
        margin-left: 1rem;
    }

    .page-content-header-text {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.64px;
        text-align: center;
        color: #4e5764;
        margin: 20px 20px 30px;
        display: block;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/EditEmployee.vue